/* Visibility only: native variant/cart/checkout handlers remain responsible for commerce. */
(() => {
 function init(){
  const root=document.querySelector('.loncry-pdp-refresh');
  if(!root||root.dataset.pdpRefreshReady)return;
  root.dataset.pdpRefreshReady='true';
  const button=root.querySelector('[data-add-to-cart]'),bar=document.querySelector('[data-pdp-sticky]');
  if(!button||!bar)return;
  const media=window.matchMedia('(max-width:640px)');
  let scheduled=false;
  function sync(){
   scheduled=false;
   const rect=button.getBoundingClientRect();
   const overlay=document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden]), .cart-drawer.is-open, .drawer.is-open, [data-cart-drawer][aria-hidden="false"]');
   const hide=!(media.matches&&rect.bottom<0&&!overlay);
   if(bar.hidden!==hide)bar.hidden=hide;
  }
  function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(sync)}}
  const observer=new IntersectionObserver(schedule,{threshold:[0,1]});observer.observe(button);
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  const mutations=new MutationObserver(schedule);mutations.observe(document.body,{subtree:true,attributes:true,attributeFilter:['class','open','aria-hidden','hidden']});
  sync();
  document.addEventListener('shopify:section:unload',()=>{if(root.isConnected)return;observer.disconnect();mutations.disconnect();window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule)});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
